import { render, staticRenderFns } from "./EmployeeHakedisUploadBordro.vue?vue&type=template&id=32f3fbd6&"
import script from "./EmployeeHakedisUploadBordro.vue?vue&type=script&lang=js&"
export * from "./EmployeeHakedisUploadBordro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports